var _defs, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 450.56 73.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #808285;\n        font-family: AdobeClean-Bold, 'Adobe Clean';\n        font-size: 68px;\n        font-weight: 700;\n      }\n\n      .cls-2 {\n        letter-spacing: .04em;\n      }\n\n      .cls-3 {\n        letter-spacing: 0em;\n      }\n\n      .cls-4 {\n        letter-spacing: 0em;\n      }\n\n      .cls-5 {\n        letter-spacing: 0em;\n      }\n\n      .cls-6 {\n        letter-spacing: 0em;\n      }\n    "))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(0 56.64) scale(.69 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Da"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 78.61,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 102.95,
    y: 0
  }, "k Sto"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 244.59,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 268.93,
    y: 0
  }, "e "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 318.64,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 352.64,
    y: 0
  }, "s a "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 444.71,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 478.84,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 512.98,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 539.36,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 572.27,
    y: 0
  }, "ice"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature5);
export default __webpack_public_path__ + "static/media/feature5.ff3b925c56888ebfa8c74db28729b9e9.svg";
export { ForwardRef as ReactComponent };